module.exports = __webpack_public_path__ + "img/02_uk.54d69f12.svg";